import { render, staticRenderFns } from "./ProductAnalyses.vue?vue&type=template&id=206c9134&scoped=true&"
import script from "./ProductAnalyses.vue?vue&type=script&lang=ts&"
export * from "./ProductAnalyses.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAnalyses.vue?vue&type=style&index=0&id=206c9134&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c9134",
  null
  
)

export default component.exports